import React, { useEffect, useState, useRef  } from 'react';
import { Layout, Menu, Button, Modal, Popover, List, Spin,Switch, Select, Form, Input, message, Typography } from 'antd';
import {
  HomeOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  CommentOutlined,
  AppstoreAddOutlined,
  SettingOutlined,
  LogoutOutlined,
  UserOutlined,
  FileDoneOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  BellOutlined,
  CloseOutlined,
  LockOutlined, 
  LoadingOutlined,
  TabletOutlined
} from '@ant-design/icons';
import { useAuth } from '../../context/DBContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const { Sider } = Layout;
const { SubMenu } = Menu;
const { Option } = Select;
const { Text } = Typography;


const LOCAL_AUTHORITIES = [
  'Aberdeen City Council',
  'Aberdeenshire Council',
  'Administration',
  'Adur District Council',
  'Allerdale Borough Council',
  'Amber Valley Borough Council',
  'Angus Council',
  'Antrim and Newtownabbey District Council',
  'Argyll & Bute Council',
  'Armagh Banbridge and Craigavon District Council',
  'Arun District Council',
  'Ashfield District Council',
  'Ashford Borough Council',
  'Aylesbury Vale District Council',
  'Babergh District Council',
  'Barnsley Metropolitan Borough Council',
  'Barrow-in-Furness Borough Council',
  'Basildon District Council',
  'Basingstoke and Deane Borough Council',
  'Bassetlaw District Council',
  'Bath and North East Somerset Council',
  'Bedford Borough Council',
  'Belfast City Council',
  'Birmingham City Council',
  'Blaby District Council',
  'Blackburn with Darwen Borough Council',
  'Blackpool Borough Council',
  'Blaenau Gwent County Borough Council',
  'Bolsover District Council',
  'Bolton Metropolitan Borough Council',
  'Boston Borough Council',
  'Bournemouth Borough Council',
  'Bournemouth, Christchurch and Poole',
  'Bracknell Forest Borough Council',
  'Braintree District Council',
  'Breckland District Council',
  'Brentwood Borough Council',
  'Bridgend County Borough Council',
  'Brighton and Hove Council',
  'Bristol City Council',
  'Broadland District Council',
  'Bromsgrove District Council',
  'Broxbourne Borough Council',
  'Broxtowe Borough Council',
  'Buckinghamshire',
  'Burnley Borough Council',
  'Bury Metropolitan Borough Council',
  'Caerphilly County Borough Council',
  'Calderdale Metropolitan Borough Council',
  'Cambridge City Council',
  'Cannock Chase District Council',
  'Canterbury City Council',
  'Cardiff County Council',
  'Carlisle City Council',
  'Carmarthenshire County Council',
  'Castle Point Borough Council',
  'Causeway Coast and Glens',
  'Central Bedfordshire',
  'Ceredigion County Council',
  'Charnwood Borough Council',
  'Chelmsford Borough Council',
  'Cheltenham Borough Council',
  'Cherwell District Council',
  'Cheshire East',
  'Cheshire West and Chester Council',
  'Chesterfield Borough Council',
  'Chichester District Council',
  'Chiltern District Council',
  'Chorley Borough Council',
  'Christchurch Borough Council',
  'City and County of Swansea',
  'City of Bradford',
  'City of Glasgow',
  'City of York Council',
  'Clackmannanshire Council',
  'Colchester Borough Council',
  'Comhairle nan Eilean Siar',
  'Conwy County Borough Council',
  'Copeland Borough Council',
  'Corby Borough Council',
  'Cornwall County Council',
  'Corporation of the City of London',
  'Cotswold District Council',
  'Coventry City Council',
  'Craven District Council',
  'Crawley Borough Council',
  'Dacorum Borough Council',
  'Darlington Borough Council',
  'Dartford Borough Council',
  'Daventry District Council',
  'Denbighshire County Council',
  'Derby City Council',
  'Derbyshire Dales District Council',
  'Derry City and Strabane District Council',
  'Doncaster Metropolitan Borough Council',
  'Dorset Council',
  'Dover District Council',
  'Dudley Metropolitan Borough Council',
  'Dumfries and Galloway Council',
  'Dundee City Council',
  'Durham',
  'East Ayrshire Council',
  'East Cambridgeshire District Council',
  'East Devon District Council',
  'East Dorset District Council',
  'East Dunbartonshire Council',
  'East Hampshire District Council',
  'East Hertfordshire District Council',
  'East Lindsey District Council',
  'East Lothian Council',
  'East Northamptonshire Council',
  'East Renfrewshire Council',
  'East Riding of Yorkshire',
  'East Staffordshire Borough Council',
  'East Suffolk Council',
  'Eastbourne Borough Council',
  'Eastleigh Borough Council',
  'Eden District Council',
  'Edinburgh City Council',
  'Elmbridge Borough Council',
  'Epping Forest District Council',
  'Epsom and Ewell Borough Council',
  'Erewash Borough Council',
  'Exeter City Council',
  'Falkirk Council',
  'Fareham Borough Council',
  'Fenland District Council',
  'Fermanagh and Omagh District Council',
  'Fife Council',
  'Flintshire County Council',
  'Folkestone & Hythe District Council',
  'Forest of Dean District Council',
  'Fylde Borough Council',
  'Gateshead Metropolitan Borough Council',
  'Gedling Borough Council',
  'Gloucester City Council',
  'Gosport Borough Council',
  'Gravesham Borough Council',
  'Great Yarmouth Borough Council',
  'Greater Manchester Authority',
  'Guildford Borough Council',
  'Gwynedd Council',
  'Halton Borough Council',
  'Hambleton District Council',
  'Harborough District Council',
  'Harlow District Council',
  'Harrogate Borough Council',
  'Hart District Council',
  'Hartlepool Borough Council',
  'Hastings Borough Council',
  'Havant Borough Council',
  'Herefordshire Council',
  'Hertsmere Borough Council',
  'High Peak Borough Council',
  'Highland Council',
  'Hinckley and Bosworth Borough Council',
  'Horsham District Council',
  'Huntingdonshire District Council',
  'Hyndburn Borough Council',
  'Inverclyde Council',
  'Ipswich Borough Council',
  'Isle of Anglesey County Council',
  'Isle of Wight Council',
  'Isles of Scilly - Council of the',
  'Kettering Borough Council',
  'Kings Lynn and West Norfolk Borough Council',
  'Kingston-upon-Hull City Council',
  'Kirklees Metropolitan Council',
  'Knowsley Metropolitan Borough Council',
  'Lancaster City Council',
  'Leeds City Council',
  'Leicester City Council',
  'Lewes District Council',
  'Lichfield District Council',
  'Lincoln City Council',
  'Lisburn City and Castlereagh District Council',
  'Liverpool City Council',
  'London Borough of Barking and Dagenham',
  'London Borough of Barnet',
  'London Borough of Bexley',
  'London Borough of Brent',
  'London Borough of Bromley Council',
  'London Borough of Camden',
  'London Borough of Croydon',
  'London Borough of Ealing',
  'London Borough of Enfield',
  'London Borough of Hackney',
  'London Borough of Hammersmith & Fulham',
  'London Borough of Haringey',
  'London Borough of Harrow',
  'London Borough of Havering',
  'London Borough of Hillingdon',
  'London Borough of Hounslow',
  'London Borough of Islington',
  'London Borough of Lambeth',
  'London Borough of Lewisham',
  'London Borough of Merton',
  'London Borough of Newham',
  'London Borough of Redbridge',
  'London Borough of Richmond',
  'London Borough of Southwark',
  'London Borough of Sutton',
  'London Borough of Tower Hamlets',
  'London Borough of Waltham Forest',
  'London Borough of Wandsworth',
  'London Borough of Westminster',
  'Luton Borough Council',
  'Maidstone Borough Council',
  'Maldon District Council',
  'Malvern Hills District Council',
  'Manchester City Council',
  'Mansfield District Council',
  'Medway Council',
  'Melton Borough Council',
  'Mendip District Council',
  'Merthyr Tydfil County Borough Council',
  'Mid and East Antrim District Council',
  'Mid Devon District Council',
  'Mid Suffolk District Council',
  'Mid Sussex District Council',
  'Mid Ulster District Council',
  'Middlesbrough Borough Council',
  'Midlothian Council',
  'Milton Keynes Borough Council',
  'Mole Valley District Council',
  'Monmouthshire Council',
  'Moray Council',
  'Neath Port Talbot County Borough Council',
  'New Forest District Council',
  'Newark and Sherwood District Council',
  'Newcastle City Council',
  'Newcastle-under-Lyme Borough Council',
  'Newport City Council',
  'Newry Mourne and Down District Council',
  'North Ayrshire Council',
  'North Devon District Council',
  'North Dorset District Council',
  'North Down and Ards District Council',
  'North East Derbyshire District Council',
  'North East Lincolnshire Council',
  'North Hertfordshire District Council',
  'North Kesteven District Council',
  'North Lanarkshire Council',
  'North Lincolnshire Council',
  'North Norfolk District Council',
  'North Somerset Council',
  'North Tyneside Council',
  'North Warwickshire Borough Council',
  'North West Leicestershire District Council',
  'Northampton Borough Council',
  'Northumberland Council',
  'Norwich City Council',
  'Nottingham City Council',
  'Nuneaton and Bedworth Borough Council',
  'Oadby and Wigston District Council',
  'Oldham Metropolitan Borough Council',
  'Orkney Islands Council',
  'Oxford City Council',
  'Pembrokeshire Council',
  'Pendle Borough Council',
  'Perth & Kinross Council',
  'Peterborough Council',
  'Plymouth City Council',
  'Poole Borough Council',
  'Portsmouth City Council',
  'Powys County Council',
  'Preston Borough Council',
  'Purbeck District Council',
  'Reading Borough Council',
  'Redcar and Cleveland Borough Council',
  'Redditch Borough Council',
  'Reigate and Banstead Borough Council',
  'Renfrewshire Council',
  'Rhondda-Cynon-Taff Council',
  'Ribble Valley Borough Council',
  'Richmondshire District Council',
  'Rochdale Metropolitan Borough Council',
  'Rochford District Council',
  'Rossendale Borough Council',
  'Rother District Council',
  'Rotherham Metropolitan Borough Council',
  'Royal Borough of Greenwich',
  'Royal Borough of Kensington & Chelsea',
  'Royal Borough of Kingston upon Thames',
  'Royal Borough of Windsor and Maidenhead',
  'Rugby Borough Council',
  'Runnymede Borough Council',
  'Rushcliffe Borough Council',
  'Rushmoor Borough Council',
  'Rutland County Council',
  'Ryedale District Council',
  'Salford Metropolitan Borough Council',
  'Sandwell Metropolitan Borough Council',
  'Scarborough Borough Council',
  'Scottish Borders Council',
  'Sedgemoor District Council',
  'Sefton Metropolitan Borough Council',
  'Selby District Council',
  'Sevenoaks District Council',
  'Sheffield City Council',
  'Shetland Islands Council',
  'Shropshire Council',
  'Slough Borough Council',
  'Solihull Metropolitan Borough Council',
  'Somerset West and Taunton Council',
  'South Ayrshire Council',
  'South Bucks District Council',
  'South Cambridgeshire District Council',
  'South Derbyshire District Council',
  'South Gloucestershire District Council',
  'South Hams District Council',
  'South Holland District Council',
  'South Kesteven District Council',
  'South Lakeland District Council',
  'South Lanarkshire Council',
  'South Norfolk District Council',
  'South Northamptonshire Council',
  'South Oxfordshire District Council',
  'South Ribble Borough Council',
  'South Somerset District Council',
  'South Staffordshire District Council',
  'South Tyneside Metropolitan Borough Council',
  'Southampton Council',
  'Southend Borough Council',
  'Spelthorne Borough Council',
  'St Albans City and District Council',
  'St Helens Metropolitan Borough Council',
  'Stafford Borough Council',
  'Staffordshire Moorlands District Council',
  'Stevenage Borough Council',
  'Stirling Council',
  'Stockport Metropolitan Borough Council',
  'Stockton-on-Tees Borough Council',
  'Stoke-on-Trent City Council',
  'Stratford on Avon District Council',
  'Stroud District Council',
  'Sunderland City Council',
  'Surrey Heath Borough Council',
  'Swale Borough Council',
  'Swindon Borough Council',
  'Tameside Metropolitan Borough Council',
  'Tamworth Borough Council',
  'Tandridge District Council',
  'Teignbridge District Council',
  'Telford and Wrekin Council',
  'Tendring District Council',
  'Test Valley Borough Council',
  'Tewkesbury Borough Council',
  'Thanet District Council',
  'Three Rivers District Council',
  'Thurrock Council',
  'Tonbridge and Malling Borough Council',
  'Torbay Borough Council',
  'Torfaen County Borough Council',
  'Torridge District Council',
  'Trafford Metropolitan Borough Council',
  'Tunbridge Wells Borough Council',
  'Uttlesford District Council',
  'Vale of Glamorgan Council',
  'Vale of White Horse District Council',
  'Wakefield Metropolitan District Council',
  'Walsall Metropolitan Borough Council',
  'Warrington Borough Council',
  'Warwick District Council',
  'Watford Borough Council',
  'Waverley Borough Council',
  'Wealden District Council',
  'Wellingborough Borough Council',
  'Welwyn Hatfield District Council',
  'West Berkshire Council',
  'West Devon Borough Council',
  'West Dorset District Council',
  'West Dunbartonshire Council',
  'West Lancashire Borough Council',
  'West Lindsey District Council',
  'West Lothian Council',
  'West Oxfordshire District Council',
  'West Suffolk Council',
  'Weymouth and Portland Borough Council',
  'Wigan Metropolitan Borough Council',
  'Wiltshire Council',
  'Winchester City Council',
  'Wirral Metropolitan Borough Council',
  'Woking Borough Council',
  'Wokingham Borough Council',
  'Wolverhampton City Council',
  'Worcester City Council',
  'Worthing Borough Council',
  'Wrexham County Borough Council',
  'Wychavon District Council',
  'Wycombe District Council',
  'Wyre Borough Council',
  'Wyre Forest District Council'
];

const Sidebar = ({ collapsed, onCollapse}) => {

  const [userInfo, setUserInfo] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [isBreakpoint, setIsBreakpoint] = useState(false); // Track when the sidebar collapses due to screen size
  const [isModalVisible, setIsModalVisible] = useState(false); // State for controlling logout modal visibility
  const { currentUser, logout, getUserInfo, forgotPassword, updateUser } = useAuth();
  const [form] = Form.useForm(); // Instantiate the form
  const [isUpdating, setIsUpdating] = useState(false); // New state for tracking update loading
  const hasLoadedRef = useRef(false); // To prevent multiple onLoad calls

  // Notification States
  const [notifications, setNotifications] = useState([
    {
      key: '1',
      title: 'New Message',
      description: 'You have received a new message from John.',
    },
    {
      key: '2',
      title: 'Server Alert',
      description: 'Server CPU usage is at 85%.',
    },
    // Add more notifications as needed
  ]);

  // Profile Popup States
  const [isForgotPasswordModalVisible, setIsForgotPasswordModalVisible] = useState(false);
  const [isEditProfileModalVisible, setIsEditProfileModalVisible] = useState(false);
  const [editProfileData, setEditProfileData] = useState({
    name: '',
    address: '',
    age: '',
    onBehalf: false,
  });

  // Handle Logout
  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch {
      console.error('Failed to log out');
      message.error('Failed to log out');
    }
  }

  const showLogoutModal = () => {
    setIsModalVisible(true);
  };

  const handleConfirmLogout = async () => {
    setIsModalVisible(false);
    await handleLogout();
  };

  const handleCancelLogout = () => {
    setIsModalVisible(false);
  };


  useEffect(() => {
    if (!hasLoadedRef.current) {
      if (currentUser) {
        getUserInfo(currentUser.uid)
          .then((data) => {
            // If data has 'name' but not 'firstName' and 'lastName', split 'name'
            let firstName = data.firstName || '';
            let lastName = data.lastName || '';
  
            if (!firstName && !lastName && data.name) {
              const nameParts = data.name.split(' ');
              firstName = nameParts[0];
              lastName = nameParts.slice(1).join(' ');
            }
  
            setUserInfo({
              ...data,
              firstName,
              lastName,
            });
  
            setEditProfileData({
              firstName,
              lastName,
              address: data.address || '',
              postcode: data.postcode || '',

              age: data.age || '',
              onBehalf: data.onBehalf || false,
              department: data.department || '',
            });
  
            hasLoadedRef.current = true;
          })
          .catch(() => {
            console.error('Failed to fetch user info');
            hasLoadedRef.current = true;
          });
      } else {
        hasLoadedRef.current = true;
      }
    }
  }, [currentUser, getUserInfo]);
  
  useEffect(() => {
    if (userInfo) {
      form.setFieldsValue({
        firstName: userInfo.firstName || '',
        lastName: userInfo.lastName || '',
        address: userInfo.address || '',
        postcode: userInfo.postcode || '',

        ...(userInfo.role === 'local-authority'
          ? { department: userInfo.department || '' }
          : { age: userInfo.age || '', onBehalf: userInfo.onBehalf || false }),
      });
    }
  }, [userInfo, form]);
  

  const getSelectedKey = () => {
    const path = location.pathname;
    if (path.includes('/adminwidget')) return 'edit-widget';
    if (path.includes('/adminproduct')) return 'edit-product';
    if (path.includes('/admin-user')) return 'admin-user';
    if (path.includes('/admin-business')) return 'admin-business';
    if (path.includes('/admin-localauthority')) return 'admin-localauthority';
    if (path.includes('/admin-pdf')) return 'admin-pdf';

    if (path.includes('/business-service')) return 'business-service';
    if (path.includes('/business-profile')) return 'business-dashboard';

    if (path.includes('/admin')) return 'admin-dashboard';
    if (path.includes('/authority')) return 'authority-dashboard';
    if (path.includes('/map')) return 'map';
    if (path.includes('/blog')) return 'blog';
    if (path.includes('/chat')) return 'chat';
    if (path.includes('/service')) return 'service';
    if (path.includes('/products')) return 'products';
    if (path.includes('/resources')) return 'resources';

    
    if (path.includes('/la-users')) return 'business-service';
    if (path.includes('/la-business')) return 'business-dashboard';

    return 'dashboard';
  };

  const renderRoleBasedMenuItems = () => {
    if (userInfo?.role === 'admin') {
      return (
        <SubMenu key="admin-submenu" title="Admin" icon={<SettingOutlined />}>
          <Menu.Item key="admin-user">
            <Link to="/admin-user">Manage User</Link>
          </Menu.Item>
          <Menu.Item key="admin-business">
            <Link to="/admin-business">Manage Business</Link>
          </Menu.Item>
          <Menu.Item key="admin-localauthority">
            <Link to="/admin-localauthority">Manage Authority</Link>
          </Menu.Item>
          <Menu.Item key="edit-product">
            <Link to="/adminproduct">Edit Product</Link>
          </Menu.Item>
          <Menu.Item key="edit-widget">
            <Link to="/adminwidget">Edit Widget</Link>
          </Menu.Item>
          <Menu.Item key="admin-pdf">
            <Link to="/admin-pdf">Manage PDFs</Link>
          </Menu.Item>
        </SubMenu>
      );
    }
    if (userInfo?.role === 'local-authority') {
      return (
        <SubMenu key="authority-submenu" title="Authority" icon={<SettingOutlined />}>
          <Menu.Item key="la-users">
          <Link to="/la-users"> Manage Users</Link>
         </Menu.Item>
          <Menu.Item key="la-business">
          <Link to="/la-business"> Manage Business</Link>
            </Menu.Item>
        </SubMenu>
      );
    }
    if (userInfo?.role === 'business') {
      return (
        <SubMenu key="business-submenu" title="Business" icon={<AppstoreAddOutlined />}>
          <Menu.Item key="business-dashboard">
            <Link to="/business-profile">Profile</Link>
          </Menu.Item>
          <Menu.Item key="business-service">
            <Link to="/business-service">Service Management</Link>
          </Menu.Item>
        </SubMenu>
      );
    }
    if (userInfo?.role === 'family') {
      return (
        <Menu.Item
          style={{ height: '50px', lineHeight: '50px' }}
          key="dashboard"
          icon={<HomeOutlined />}
        >
          <Link to="/dashboard">My enableSEND</Link>
        </Menu.Item>
      );
    }
    return null;
  };



  const renderRoleBasedMenuItems2 = () => {
    
    if (userInfo?.role === 'local-authority') {
      return (
       
        <Menu.Item
        style={{ height: '50px', lineHeight: '50px' }}
        key="contact"
        icon={<TabletOutlined />}
      >
        <Link to="/contact">My SEND Consultancy</Link>
      </Menu.Item>
      );
    }
    if (userInfo?.role === 'business') {
      return (
       
        <Menu.Item
        style={{ height: '50px', lineHeight: '50px' }}
        key="contact"
        icon={<TabletOutlined />}
      >
        <Link to="/contact">My SEND Consultancy</Link>
      </Menu.Item>
      );
    }
   
    return null;
  };
  

  // Handle Removing Notifications
  const handleRemoveNotification = (key) => {
    setNotifications((prev) => prev.filter((notif) => notif.key !== key));
  };

  // Handle Profile Popup Actions
  const handleForgotPassword = () => {
    setIsForgotPasswordModalVisible(true);
  };

  const handleForgotPasswordOk = () => {
    setIsForgotPasswordModalVisible(false);
    message.success('A password reset link has been sent to your email.');
  };

  const handleForgotPasswordSubmit = () => {
    const email = currentUser?.email; // Ensure you have the current user's email
    if (email) {
      forgotPassword(email)
        .then(() => {
          message.success('Password reset email has been sent.');
          setIsForgotPasswordModalVisible(false);
        })
        .catch(error => {
          console.error('Forgot password error:', error);
          message.error('Failed to send password reset email. ' + error.message);
        });
    } else {
      message.error('No email address is available.');
    }
  };
  

  const handleEditProfile = () => {
    setIsEditProfileModalVisible(true);
  };

  const handleEditProfileOk = () => {
    // Here you would typically handle the profile update logic, such as making an API call
    // For demonstration, we'll just close the modal and show a success message
    setIsEditProfileModalVisible(false);
    message.success('Profile updated successfully.');
  };

  const handleEditProfileSubmit = (values) => {
    setIsUpdating(true);

    updateUser(currentUser.uid, values).then(() => {
        message.success('Profile updated successfully.');
        setIsEditProfileModalVisible(false);
    }).catch(error => {
        message.error('Failed to update profile.');
    });
    setIsUpdating(false);

};

  
  const [isProfilePopoverVisible, setIsProfilePopoverVisible] = useState(false);
  const [isNotificationPopoverVisible, setIsNotificationPopoverVisible] = useState(false);
  


  return (
    <>
      {/* Logout confirmation modal */}
      <Modal
        title="Log Out"
        visible={isModalVisible}
        onOk={handleConfirmLogout}
        onCancel={handleCancelLogout}
        okText="Yes"
        cancelText="No"
      >
        <p>Are you sure you want to log out?</p>
      </Modal>

      {/* Forgot Password Modal */}
      <Modal
  title="Forgot Password"
  visible={isForgotPasswordModalVisible}
  onOk={handleForgotPasswordSubmit} // Ensure this is calling the correct function
  onCancel={() => setIsForgotPasswordModalVisible(false)}
  okText="Send Reset Email"
  cancelText="Cancel"
>
  <p>Please confirm to send a password reset email to your account.</p>

      </Modal>

      {/* Edit Profile Modal */}
      <Modal
        title="Edit Profile Settings"
        visible={isEditProfileModalVisible}
        onOk={() => form.submit()}
        onCancel={() => setIsEditProfileModalVisible(false)}
        footer={[
          <Button key="back" onClick={() => setIsEditProfileModalVisible(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={isUpdating} onClick={() => form.submit()}>
            Save
          </Button>,
        ]}
        confirmLoading={isUpdating}
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            firstName: userInfo?.firstName || '',
            lastName: userInfo?.lastName || '',
            address: userInfo?.address || '',
            postcode: userInfo?.postcode || '',
            laRep: userInfo?.laRep || ''
          }}
          onFinish={handleEditProfileSubmit}
        >
          <Form.Item 
            name="firstName" 
            label="First Name" 
            rules={[{ required: true, message: 'Please input your first name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="lastName" 
            label="Last Name" 
            rules={[{ required: true, message: 'Please input your last name!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="address" 
            label="Address" 
            rules={[{ required: true, message: 'Please input your address!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="postcode" 
            label="Postcode" 
            rules={[{ required: true, message: 'Please input your postcode!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item 
            name="laRep" 
            label="Local Authority" 
            rules={[{ required: true, message: 'Please select your local authority!' }]}
          >
            <Select placeholder="Select your local authority">
              <Option value="None">None</Option>
              {LOCAL_AUTHORITIES.map((authority) => (
                <Option key={authority} value={authority}>
                  {authority}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>

      {/* Toggle button should only appear when the sidebar is collapsed due to breakpoint */}
      {isBreakpoint && (
        <Button
          type="default"
          onClick={() => onCollapse(!collapsed)}
          style={{
            position: 'fixed',
            top: 20,
            right: 20,
            zIndex: 1000,
            backgroundColor: 'transparent',
            border: '1px solid #000',  // This will now be visible
            padding: '5px 10px',
          }}
          icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        />
      )}

      <Sider
        width={220}
        trigger={null}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100vh',
          backgroundColor: '#fff',
          padding: '0',
          position: 'fixed',
          top: 0,
          left: 0,
          
        }}
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        breakpoint="lg" // Collapse at "lg" breakpoint
        collapsedWidth={0} // Fully collapse sidebar at breakpoint
        onBreakpoint={(broken) => setIsBreakpoint(broken)} // Detect when the breakpoint is hit
      >
        {/* Top Section (Logo and Menu) */}
        <div style={{ flex: '1 1 auto', overflowY: 'auto' }}>
        {/* Logo Section */}
        <div className="flex justify-center py-4">
  <a href="/">
    <img src="/assets/enablelogo.png" alt="Logo" className="w-[120px]" />
  </a>
</div>


          {/* Menu */}
          <Menu
            mode="vertical"
            selectedKeys={[getSelectedKey()]}
            style={{
              fontSize: '14px', // Bigger text for menu
              borderRight: 'none',
            }}
          >
            {/* Render role-based items */}
            {renderRoleBasedMenuItems()}

            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="map"
              icon={<EnvironmentOutlined />}
            >
              <Link to="/map">My SEND Map</Link>
            </Menu.Item>
            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="service"
              icon={<AppstoreAddOutlined />}
            >
              <Link to="/service">My SEND Services</Link>
            </Menu.Item>
            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="blog"
              icon={<FileTextOutlined />}
            >
              <Link to="/blog">SEND News</Link>
            </Menu.Item>
            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="chat"
              icon={<CommentOutlined />}
            >
              <Link to="/chat">My SEND Chat</Link>
            </Menu.Item>
          
            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="products"
              icon={<ShoppingCartOutlined />}
            >
              <Link to="/products">My SEND products</Link>
            </Menu.Item>
            <Menu.Item
              style={{ height: '50px', lineHeight: '50px' }}
              key="resources"
              icon={<FileDoneOutlined />}
            >
              <Link to="/resources">My SEND Resources</Link>
            </Menu.Item>


            {renderRoleBasedMenuItems2()}

          </Menu>
        </div>

       {/* Bottom Section */}
{/* Bottom Section */}
<div
  style={{
    padding: '10px 0',
    display: 'flex',
    justifyContent: 'space-around',
    borderTop: '1px solid #f0f0f0',
    marginTop: '65px',
  }}
>
{/* <Popover
  placement="topRight"
  title="Profile"
  content={
    <div style={{
      width: '200px',
      textAlign: 'left',
    }}>
      <Button
        type="text"
        icon={<LockOutlined />}
        onClick={() => {handleForgotPassword(); setIsProfilePopoverVisible(false);}}
        block
        style={{
          justifyContent: 'flex-start', // Align icon and text to the left
          marginBottom: '10px' // Add margin between the buttons
        }}
      >
        Forgot Password
      </Button>
      <Button
        type="text"
        icon={<SettingOutlined />}
        onClick={() => {handleEditProfile(); setIsProfilePopoverVisible(false);}}
        block
        style={{
          justifyContent: 'flex-start', // Align icon and text to the left
        }}
      >
        Change Account Settings
      </Button>
    </div>
  }
  trigger="click"
  visible={isProfilePopoverVisible} // Manage visibility
  onVisibleChange={setIsProfilePopoverVisible} // Control the visibility
>
  <Button
    type="text"
    icon={<UserOutlined style={{ fontSize: '14px' }} />}
    shape="circle"
    size="large"
    style={{
      backgroundColor: '#f0f0f0',
      borderRadius: '8px', // Slightly rounded corners
      padding: '5px 10px',
    }}
  />
</Popover> */}



  


    {/* change profile Icon */}
  {/* Only show update icon if role is not 'business' */}
{userInfo?.role !== 'business' && (
  <Button
    type="text"
    icon={<SettingOutlined style={{ fontSize: '14px' }} />}
    onClick={() => {handleEditProfile(); setIsProfilePopoverVisible(false);}}
    shape="circle"
    size="large"
    style={{
      backgroundColor: '#f0f0f0',
      borderRadius: '8px',
      padding: '5px 10px',
    }}
  />
)}


    {/* forgotpassword Icon */}
    <Button
    type="text"
    icon={<LockOutlined style={{ fontSize: '14px' }} />}
    onClick={() => {handleForgotPassword(); setIsProfilePopoverVisible(false);}}
    shape="circle"
    size="large"
    style={{
      backgroundColor: '#f0f0f0',
      borderRadius: '8px', // Slightly rounded corners
      padding: '5px 10px',
    }}
  />


 {/* Logout Icon */}
 <Button
    type="text"
    icon={<LogoutOutlined style={{ fontSize: '14px' }} />}
    onClick={showLogoutModal}
    shape="circle"
    size="large"
    style={{
      backgroundColor: '#f0f0f0',
      borderRadius: '8px', // Slightly rounded corners
      padding: '5px 10px',
    }}
  />

      
{/* Notification Icon
<Popover
  placement="topRight"
  title="Notifications"
  content={
    <div style={{ width: '250px', padding: '10px' }}> 
      {notifications.length === 0 ? (
        <Text>No new notifications</Text>
      ) : (
        <List
          dataSource={notifications}
          renderItem={(item) => (
            <List.Item
              actions={[
                <CloseOutlined
                  key="close"
                  onClick={() => handleRemoveNotification(item.key)}
                />,
              ]}
            >
              <List.Item.Meta
                avatar={<BellOutlined style={{ color: '#1890ff', fontSize: '16px' }} />} 
                title={<Text style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.title}</Text>} 
                description={
                  <Text style={{ fontSize: '11px', color: '#555' }}>{item.description}</Text> 
                }
              />
            </List.Item>
          )}
        />
      )}
    </div>
  }
  trigger="click"
  visible={isNotificationPopoverVisible} 
  onVisibleChange={setIsNotificationPopoverVisible} 
>
  <Button
    type="text"
    icon={<BellOutlined style={{ fontSize: '14px' }} />} 
    shape="circle"
    size="large"
    style={{
      backgroundColor: '#f0f0f0', 
      borderRadius: '8px', 
      padding: '5px 10px', 
    }}
  />
</Popover> */}

</div>



      </Sider>
    </>
  );
};

export default Sidebar;
